<template>
  <div class="wareApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading"> 
    <div style="height:15px;"></div> 
    <div class="order-item">
      <div class="title">
        <div class="address">{{detail.name}}（{{detail.idCard}}）</div>
      </div>
      <div class="product">
        <div class="goods">
          <img class="left" :src="baseUrl+detail.image" />
          <div class="right">
            <p>{{detail.title}}</p>
            <div class="num">数量：{{detail.num}}件</div>
            <div class="price">
              <i>￥</i><b>{{detail.price.split(".")[0]}}</b>
              <i>.{{detail.price.split(".")[1]}}</i>
            </div>
          </div>
        </div>
        <div class="names">
          <div class="timer">购买时间：{{detail.createtime}}</div>
          <div class="timer" >订单编号：{{detail.number}}</div>
        </div>
      </div>
    </div> 

     <ul class="lsls first">
      <li>
        <span>验收物品描述</span>
        <input v-model="content" readonly type="text" placeholder="请输入验收物品描述"/>
      </li>
      <li>
        <span>是否损坏</span>
        <input v-model="value" readonly type="text" placeholder="请输入验收物品描述"/>
      </li>
      <li>
        <span>物品损坏赔偿金额</span>
        <input v-model="price" type="text" readonly />
      </li>
    </ul>
    <ul class="lsls">
      <li>
        <span>拍照验收</span>
        <img class="icon" src="~assets/images/icon5.png" />
        <img v-for="(item,i) in img" class="imgs" :src="baseUrl+item"/>
      </li>
    </ul>

    <div style="height:30px"></div>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        detail:[],
        userData:[],
        options: [{
          value: '1',
          label: '否'
        }, {
          value: '2',
          label: '是'
        }],
        value: '',
        img:[],
        content:'',
        price:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.getQqueyImg();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      getDetail:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/store/ware',
          params:{
            order_id:id,
          }
        }).then(function(response){
          var res = response.data.data;
          that.detail = res.rs;
          that.content = res.ware.content;
          that.price = res.ware.price;
          that.value = (res.ware.status == 1 ? '完好归还' : '存在有损坏情况');
          that.img = res.ware.img;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      getQqueyImg:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData',
              'previewImage'
            ]
          });
          wx.ready(function() {
            $('.imgs').on('click', function() {
              var img = $(this).attr('src');
              wx.previewImage({
                current: img, // 当前显示图片的http链接
                urls: img // 需要预览的图片http链接列表
              });
            })


          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .wareApp{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
  }

  .wareApp .order-tab{
    position:fixed;
    width:100%;
    height:45px;
    left:0;
    top:0;
    background:#f7faff;
    z-index:99
  }
  .wareApp .order-tab span{
    display:inline-block;
    width:20%;
    text-align:center;
    line-height:45px;
    font-size:15px;
    font-weight:bold;
    color:#666;
    position:relative;
  }
  .wareApp .order-tab span.curt{
    color:#333;
  }
  .wareApp .order-tab span.curt:after{
    position:absolute;
    content:'';
    width:30px;
    height:2px;
    background:#406DE1;
    bottom:5px;
    left:50%;
    transform: translateX(-50%);
  }
  .wareApp .order-item{
    width: 94%;
    display: block;
    margin: 0px auto 10px auto;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
  }
  .wareApp .order-item .title{
    height: 50px;
    display: block;
    line-height: 51px;
    border-bottom:solid 1px #EBF2FF;
    width:90%;
    margin:0 auto;
  }
  .wareApp .order-item .title .address{
    float: left;
    font-size: 16px;
    font-weight:bold;
  }
  .wareApp .order-item .title .make{
    float:right;
    font-size:14px;
    color:#406DE1;
  }
  .wareApp .order-item .product:after,.wareApp .order-item .btn:after,.wareApp .goods:after {
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
  } 
  .wareApp .order-item .product .names{
    margin:0 auto;
    position:relative;
    width:90%;
  }
  .wareApp .order-item .product .names .bt{
    font-size: 15px;
    color: #000;
    width: 100%;
    height:45px;
    line-height: 45px;
  }
  .wareApp .order-item .product .names .bt span{
    float:right;
    color:#666;
    margin-right:15px;
    font-size:16px;
  }
  .wareApp .order-item .product .names .timer{
    font-size: 14px;
    color: #999;
    padding:10px 0;
    border-bottom:1px #f5f5f5 solid;
  }
  .wareApp .order-item .product .names .timer:last-child{
    border-bottom:none;
  }
  .wareApp .none{
    text-align:center;
    padding-top:50%
  }
  .wareApp .none img{
    width:90%;
    display:block;
    margin:0 auto;
  }

  .wareApp .goods .left{
    float:left;
    width:20%;
    border-radius:5px;
    margin:4% 2% 2% 4%;
  }
  .wareApp .goods .right{
    float:left;
    margin-top:4%;
    width:69%;
    border-bottom:solid 1px #f5f5f5;
    position: relative;
    min-height:52px;
  }
  .wareApp .goods .right p{
    letter-spacing:1px;
    font-size:16px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#333;
    width:78%
  }
  .wareApp .goods .right p font{
    background:#f00;
    color:#fff;
    border-radius:5px;
    font-size:13px;
    position: relative;
    padding:2px;
    top:-2px;
    margin-right:2px
  }
  .wareApp .goods .right .num{
    font-size: 14px;
    color: #999999;
    padding-top:8px;
  }
  .wareApp .goods .right .price{
    color:#f00;
    font-size:15px;
    position: absolute;
    top:0;
    right:0;
    text-align:right
  }
  .wareApp .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }
  .wareApp .goods .right .price b{
    color: #FF6600;
    font-size:18px;
    font-weight:600;
  }

  .wareApp .goods .right .price i{
    color: #FF6600;
    font-size:13px;
    font-style:normal
  }
  
  .wareApp .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }

  .wareApp ul.lsls{
    display:block;
    width:93%;
    background:#fff;
    margin:0 auto;
    margin-bottom:50px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
  }
  .wareApp ul.first{
    margin-bottom:10px;
  }
  .wareApp ul.lsls li{
    width:92%;
    margin:0 auto;
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0;
    position: relative;
  }
  .wareApp ul.lsls li:last-child{
    border-bottom:none;
  }
  .wareApp ul.lsls li font{
    position:absolute;
    right:15px;
    bottom:15px;
    font-size:16px;
    color:#FF751A
  }
  .wareApp ul.lsls li .icon{
    position:absolute;
    right:10px;
    top:20px;
    width:8px
  }
  .wareApp ul li:first-child h2{
    font-size:18px
  }
  .wareApp li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .wareApp ul li span{
    display:block;
    width:100%;
    font-size:16px;
    padding-bottom:15px
  }
  .wareApp ul li input{
    display:block;
    width:100%;
    background:none;
    border:none;
    outline:none;
    font-size:16px;
    margin-top:1px;
    height: 32px;
    line-height: 32px;
  }
  .wareApp ul li .imgs{
    width:31%;
    margin-right:2%
  }
  .wareApp ul li .checkbox{
    float:right;
    width:auto !important;
    margin-right:30px;
    margin-top:4px
  }

  .wareApp .addAddress{
    display:block;
    margin:0 auto;
    width:80%;
    height:45px;
    border:none;
    background:#2F78FF;
    color:#fff;
    font-size:16px;
    border-radius:45px;
  }
  .wareApp .el-select{
    display:block !important;
  }
  .wareApp .el-select span{
    display:block !important;
    width:auto !important;
    padding-bottom:0 !important;
  }
  .wareApp  .el-input__inner{
    padding:0;
  }
</style>